var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    className: "st0",
    d: "M12,1.5c0.3,0,0.6,0.1,0.8,0.3c0.2,0.2,0.4,0.4,0.5,0.7l10.4,18c0.1,0.1,0.2,0.3,0.2,0.5 C24,21,24,21.2,24,21.4c0,0.4-0.2,0.8-0.5,1c-0.3,0.2-0.7,0.3-1.1,0.3H1.6c-0.4,0-0.8-0.1-1.1-0.3c-0.3-0.2-0.5-0.6-0.5-1 c0-0.4,0.1-0.7,0.3-1l10.4-18c0.1-0.2,0.3-0.5,0.5-0.7C11.4,1.6,11.7,1.5,12,1.5z M12.9,16.6c0.1,0,0.2-0.1,0.3-0.1 c0.1-0.1,0.1-0.2,0.1-0.3l0.2-8.6c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.3-0.1h-2.2c-0.1,0-0.3,0-0.3,0.1 c-0.1,0.1-0.1,0.2-0.1,0.3l0.2,8.6c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0.1H12.9z M13.5,18.4c0-0.1,0-0.3-0.1-0.4 c-0.1-0.1-0.2-0.1-0.3-0.1H11c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.2-0.1,0.4v2c0,0.1,0,0.3,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0.1H13 c0.2,0,0.4-0.1,0.5-0.3c0,0,0-0.1,0-0.1L13.5,18.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.141c4f01c3e8c705562c6927e8f73449.svg";
export { ForwardRef as ReactComponent };